<template>
  <div class="el-card mt-24 p-16">
    <MyTitle class="mb-16">
      产业发展趋势
    </MyTitle>
    <div class="fx-wrap">
      <div class="title pt-1">企业分布·工商企业规模发展趋势</div>
      <MyEcharts ref="chartFirst" class="w50 h300" />
      <MyEcharts ref="chartFirst2" class="w25 h300" />
      <MyEcharts ref="chartFirst3" class="w25 h300" />
      <div class="title">二级市场·上市公司业务发展趋势</div>
      <MyEcharts ref="chartFirst4" class="w50 h300" />
      <MyEcharts ref="chartFirst5" class="w50 h300" />
      <div class="title">一级市场·投融资趋势</div>
      <MyEcharts ref="chartFirst6" class="w50 h300" />
      <MyEcharts ref="chartFirst7" class="w50 h300" />
      <div class="title">科技属性·专利资质发展趋势</div>
      <MyEcharts ref="chartFirst8" class="w50 h300" />
      <MyEcharts ref="chartFirst9" class="w25 h300" />
      <MyEcharts ref="chartFirst10" class="w25 h300" />
    </div>
  </div>

</template>

<script>
import MyTitle from '@/views/industryChainNew/components/myTitle'
import MyEcharts from '@/components/myEcharts'
import { levelTwo, companyCountChart, smallPieChart, barChart, pieChart, lineChart } from '../components/echartsOptions'
import analysis from '@/views/industryChainNew/markData/analysis'
import { getChainAnalysis } from '@/views/industryChainNew/api'

export default {
  name: 'IndustryAnalyze',
  components: {
    MyTitle,
    MyEcharts
  },
  props: {

  },
  data() {
    return {
    }
  },
  computed: {
    ID() {
      return this.$route?.query?.id
    }
  },
  mounted() {
    this.getChainAnalysis()
  },
  methods: {
    async getChainAnalysis() {
      const [err, res] = await this.$reqFn(getChainAnalysis, {
        secId: this.ID,
      })
      if (res && res.code === 200) {
        this.analysis = res.data || {}
        this.initCharts()
      }
    },
    initCharts() {
      const {
        companyCount, yearsStatistical,
        regCapitalStatistics, pevcTrendList, takingTrend, grossProfitMargin, technologyTrends,
        patentTypesDistribution, qualCompanyStatistical
      } = this.analysis
      this.$refs.chartFirst.update(companyCountChart(companyCount))
      this.$refs.chartFirst2.update(smallPieChart(yearsStatistical, '企业成立年限分布'))
      this.$refs.chartFirst3.update(smallPieChart(regCapitalStatistics, '企业注册资本分布'))

      this.$refs.chartFirst4.update(levelTwo(takingTrend, ['全国产品线营业收入', '全国产品线营业收入增速'], '营业收入趋势'))
      this.$refs.chartFirst5.update(levelTwo(grossProfitMargin, ['全国产品线毛利润', '全国产品线毛利润增速'], '毛利润趋势'))

      this.$refs.chartFirst6.update(barChart(pevcTrendList))
      // this.$refs.chartFirst6.getChartObj().getZr().on('click', params => {

      //   // 获取到鼠标点击位置：
      //   const pointInPixel = [params.offsetX, params.offsetY]
      //   // 使用containPixel API判断点击位置是否在显示图形区域
      //   if (this.$refs.chartFirst6.getChartObj().containPixel('grid', pointInPixel)) {
      //     // 使用API convertFromPixel获取点击位置对应的x轴数据的索引值
      //     let path = this.$refs.chartFirst6.getChartObj().convertFromPixel({ xAxisIndex: 0 }, [params.offsetX, params.offsetY])
      //     // 控制台打印数据的名称
      //     console.log(params.name);
      //     const res = pevcTrendList.find(e => e.year == params.name)
      //     const data = pieChart(res)
      //     this.$refs.chartFirst7.update(data)
      //   }

      // })
      this.$refs.chartFirst6.getChartObj().on('click', params => {
        console.log(params.name);
        const res = pevcTrendList.find(e => e.year == params.name)
        const data = pieChart(res)
        this.$refs.chartFirst7.update(data)
      })

      let pieChartData
      for (let index = pevcTrendList.length - 1; index > 0; index--) {
        pieChartData = pevcTrendList[index]
        if (pieChartData.detailList.length) break
      }

      this.$refs.chartFirst7.update(pieChart(pieChartData))

      this.$refs.chartFirst8.update(lineChart(technologyTrends))
      this.$refs.chartFirst9.update(smallPieChart(patentTypesDistribution, '专利类型分布'))
      this.$refs.chartFirst10.update(smallPieChart(qualCompanyStatistical, '资质企业统计'))
    }
  },
}
</script>

<style scoped lang="scss">
.title {
  font-size: 16px;
  font-weight: 500;
  color: #186bfc;
  padding: 32px 0 16px;
  width: 100%;
}
.h300 {
  height: 300px;
}
.w50 {
  width: 50%;
}
.w25 {
  width: 25%;
}
</style>
